module.exports = __webpack_public_path__ + "img/list_Portrait_04.20a74e56.jpeg";